module.exports = __webpack_public_path__ + "images/emoji/ideograph_advantage.5101fb2297586dd6c874.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ideograph_advantage.png
// module id = la+h
// module chunks = 14